import { defineComponent as _defineComponent } from 'vue'
import { AbLink } from '../../ui';
import { CdnImg } from '@webplatform/cdn-image';

interface CatalogProduct {
  productId?: string | null;
  customLink?: string | null;
  description?: string | null;
  priceText?: string | null;
  image?: {
    src?: string | null;
    alt?: string | null;
  } | null;
  name?: string | null;
  sku?: string | null;
  price?: string | null;
  link?: string | null;
  disableClick?: boolean | null;
}

interface Props {
  hideSku?: boolean | null;
  hidePrice?: boolean | null;
  items?: CatalogProduct[];
}


export default /*#__PURE__*/_defineComponent({
  __name: 'AbCatalogCards',
  props: {
    hideSku: { type: [Boolean, null] },
    hidePrice: { type: [Boolean, null] },
    items: null
  },
  setup(__props: any) {



const getProductLink = (card: CatalogProduct) => {
  return !card.disableClick && (card.customLink || card.link);
};

return { __sfc: true,getProductLink, AbLink, CdnImg }
}

})